/**
 * Jeu d'icônes SVG (stroke) maison — léger, cohérent, sans dépendance.
 * Toutes héritent de `currentColor`.
 */
import React from 'react';

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  viewBox: '0 0 24 24',
};

export const IconGrid = (p) => (
  <svg {...base} {...p}><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /></svg>
);
export const IconFlow = (p) => (
  <svg {...base} {...p}><circle cx="5" cy="6" r="2" /><circle cx="19" cy="18" r="2" /><path d="M7 6h6a4 4 0 0 1 4 4v6" /><path d="m14 13 3 3 3-3" /></svg>
);
export const IconDesert = (p) => (
  <svg {...base} {...p}><path d="M3 20h18" /><path d="M7 20V9l3-3 3 3v11" /><path d="M14 20v-6l3-2 3 2v6" /></svg>
);
export const IconForecast = (p) => (
  <svg {...base} {...p}><path d="M3 16l5-6 4 3 5-7" /><path d="M17 6h4v4" /><path d="M3 20h18" /></svg>
);
export const IconAlert = (p) => (
  <svg {...base} {...p}><path d="M12 3 2.5 19.5h19L12 3Z" /><path d="M12 10v4" /><path d="M12 17.5h.01" /></svg>
);
export const IconUsers = (p) => (
  <svg {...base} {...p}><circle cx="9" cy="8" r="3" /><path d="M3.5 20a5.5 5.5 0 0 1 11 0" /><path d="M16 5.5a3 3 0 0 1 0 5.4" /><path d="M17.5 20a5.5 5.5 0 0 0-3-4.9" /></svg>
);
export const IconRoute = (p) => (
  <svg {...base} {...p}><circle cx="6" cy="19" r="2" /><circle cx="18" cy="5" r="2" /><path d="M8 19h6a4 4 0 0 0 0-8H10a4 4 0 0 1 0-8h6" /></svg>
);
export const IconPin = (p) => (
  <svg {...base} {...p}><path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11Z" /><circle cx="12" cy="10" r="2.5" /></svg>
);
export const IconPulse = (p) => (
  <svg {...base} {...p}><path d="M3 12h4l2-6 4 14 2-8h6" /></svg>
);
export const IconTrendUp = (p) => (
  <svg {...base} {...p}><path d="m4 17 6-6 4 4 6-7" /><path d="M16 8h5v5" /></svg>
);
export const IconTrendDown = (p) => (
  <svg {...base} {...p}><path d="m4 7 6 6 4-4 6 7" /><path d="M16 16h5v-5" /></svg>
);
export const IconBus = (p) => (
  <svg {...base} {...p}><rect x="4" y="4" width="16" height="13" rx="2.5" /><path d="M4 11h16" /><path d="M7 20v-3M17 20v-3" /><circle cx="8" cy="14" r="0.6" fill="currentColor" /><circle cx="16" cy="14" r="0.6" fill="currentColor" /></svg>
);

export const IconCalendar = (p) => (
  <svg {...base} {...p}><rect x="3" y="4.5" width="18" height="16" rx="2.5" /><path d="M3 9h18M8 2.5v4M16 2.5v4" /></svg>
);
export const IconLayers = (p) => (
  <svg {...base} {...p}><path d="m12 3 9 5-9 5-9-5 9-5Z" /><path d="m3 13 9 5 9-5" /></svg>
);
export const IconSliders = (p) => (
  <svg {...base} {...p}><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0" /><circle cx="16" cy="6" r="2" /><circle cx="10" cy="12" r="2" /><circle cx="18" cy="18" r="2" /></svg>
);
export const IconScale = (p) => (
  <svg {...base} {...p}><path d="M12 3v18M5 7h14" /><path d="M5 7 2.5 13a3 3 0 0 0 5 0L5 7ZM19 7l-2.5 6a3 3 0 0 0 5 0L19 7ZM8 21h8" /></svg>
);
export const IconCube = (p) => (
  <svg {...base} {...p}><path d="M12 2.5 21 7v10l-9 4.5L3 17V7l9-4.5Z" /><path d="m3 7 9 4.5L21 7M12 11.5V21.5" /></svg>
);
export const IconDatabase = (p) => (
  <svg {...base} {...p}><ellipse cx="12" cy="5.5" rx="8" ry="3" /><path d="M4 5.5v13c0 1.7 3.6 3 8 3s8-1.3 8-3v-13M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" /></svg>
);
export const IconCode = (p) => (
  <svg {...base} {...p}><path d="m8 8-5 4 5 4M16 8l5 4-5 4M13 5l-2 14" /></svg>
);
export const IconRadar = (p) => (
  <svg {...base} {...p}><path d="M12 12 19 6" /><path d="M12 3a9 9 0 1 0 9 9" /><path d="M12 8a4 4 0 1 0 4 4" /><circle cx="12" cy="12" r="1" fill="currentColor" /></svg>
);

export const IconLogout = (p) => (
  <svg {...base} {...p}><path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" /><path d="M10 17l-5-5 5-5M5 12h12" /></svg>
);

export const Logo = (p) => (
  <svg viewBox="0 0 32 32" width="22" height="22" {...p}>
    <path d="M6 22c5-12 15-12 20 0" stroke="#fff" strokeWidth="2.6" fill="none" strokeLinecap="round" />
    <circle cx="6" cy="22" r="2.6" fill="#fff" />
    <circle cx="26" cy="22" r="2.6" fill="#fff" />
  </svg>
);
